import React, { useState } from 'react';
import { Check, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const plans = {
  monthly: [
    {
      title: 'Free',
      desc: 'Explore AI with basic Q&A.',
      price: '$0',
      billed: 'Billed monthly',
      buttonText: 'Current',
      features: ['Limited basic queries', 'Real-time answers powered by live web search'],
    },
    {
      title: 'Pro',
      desc: 'Meet all your personal goals with expanded access to AI Agents.',
      price: '$20',
      billed: 'monthly, billed $180/year',
      buttonText: 'Get Pro',
      features: [
        'Access to all AI models from OpenAI, Anthropic, DeepSeek, Google, and more',
        'Unlock Research and custom agents',
        'Upload files & images to extract insights',
      ],
    },
    {
      title: 'Max',
      desc: 'Supercharge your productivity with the best of AI, including ARI access.',
      price: '$200',
      billed: 'monthly, billed $2100/year',
      buttonText: 'Get Max',
      features: [
        'Everything in Pro',
        'Unlimited ARI Reports',
        'Increased file upload capacity for richer research and more complex tasks',
        'Zero data retention and no-training for models',
      ],
    },
  ],
  yearly: [
    {
      title: 'Free',
      desc: 'Explore AI with basic Q&A.',
      price: '$0',
      billed: 'Billed monthly',
      buttonText: 'Current',
      features: ['Limited basic queries', 'Real-time answers powered by live web search'],
    },
    {
      title: 'Pro',
      desc: 'Meet all your personal goals with expanded access to AI Agents.',
      price: '$20',
      billed: 'monthly, billed $180/year',
      buttonText: 'Get Pro',
      features: [
        'Access to all AI models from OpenAI, Anthropic, DeepSeek, Google, and more',
        'Unlock Research and custom agents',
        'Upload files & images to extract insights',
      ],
    },
    {
      title: 'Max',
      desc: 'Supercharge your productivity with the best of AI, including ARI access.',
      price: '$200',
      billed: 'monthly, billed $2100/year',
      buttonText: 'Get Max',
      features: [
        'Everything in Pro',
        'Unlimited ARI Reports',
        'Increased file upload capacity for richer research and more complex tasks',
        'Zero data retention and no-training for models',
      ],
    },
  ],
};

const PlanSection = () => {
  const [activeTab, setActiveTab] = useState('monthly');
  const navigate = useNavigate();

  return (
    <div>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-sm text-[#a0a0a0] hover:text-white mb-8">
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-white mb-6 font-serif">Upgrade your plan</h1>
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-[#161616] border border-[#262626]">
            {['monthly', 'yearly'].map(tab => (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-1.5 rounded-full text-sm font-medium capitalize transition-colors ${
                  activeTab === tab ? 'bg-primary text-black' : 'text-[#a0a0a0] hover:text-white'
                }`}>
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {plans[activeTab].map(plan => (
            <div
              key={plan.title}
              className={`flex flex-col p-6 rounded-xl bg-[#161616] border transition-colors ${
                plan.title === 'Free'
                  ? 'border-[#262626]'
                  : 'border-[#262626] hover:border-primary/40'
              }`}>
              <h3 className="text-lg font-semibold text-white font-serif mb-1">{plan.title}</h3>
              <p className="text-sm text-[#a0a0a0] leading-relaxed min-h-[40px]">{plan.desc}</p>

              <div className="my-5">
                <span className="text-4xl font-bold text-white">{plan.price}</span>
                <span className="block text-xs text-[#707070] mt-1">{plan.billed}</span>
              </div>

              {plan.title === 'Free' ? (
                <button
                  type="button"
                  disabled
                  className="w-full py-2.5 rounded-full text-sm font-medium transition-colors mb-6 bg-white/5 text-[#808080] border border-[#262626] cursor-default">
                  {plan.buttonText}
                </button>
              ) : (
                <button
                  type="button"
                  className="w-full py-2.5 rounded-full text-sm font-medium transition-colors mb-6 bg-primary hover:bg-primary/90 text-black">
                  {plan.buttonText}
                </button>
              )}

              <ul className="space-y-3 mt-auto">
                {plan.features.map(f => (
                  <li
                    key={f}
                    className="flex items-start gap-2.5 text-sm text-[#c8c8c8] leading-relaxed">
                    <Check className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanSection;
